// extracted by mini-css-extract-plugin
export default {"logoPlaceholder":"styles---logoPlaceholder---pP6oN","bannerActions":"styles---bannerActions---gn7HG"};